export const formatCurrency = (amount, currency = 'ZAR', decimals = 2) => {
  return `${amount.toFixed(decimals)} ${currency}`;
};

/**
 * Convert an amount from one currency to another using exchange pair data.
 * Tries direct pair (uses sell_rate), then reverse pair (1/buy_rate).
 * Returns null when no conversion route exists.
 */
export const convertAmount = (amount, fromCurrency, toCurrency, pairs = []) => {
  if (amount == null || isNaN(amount)) return null;
  if (!fromCurrency || !toCurrency) return null;
  if (fromCurrency === toCurrency) return amount;
  const direct = pairs.find(
    (p) => p.from_currency === fromCurrency && p.to_currency === toCurrency && p.sell_rate
  );
  if (direct) return amount * direct.sell_rate;
  const reverse = pairs.find(
    (p) => p.from_currency === toCurrency && p.to_currency === fromCurrency && p.buy_rate
  );
  if (reverse) return amount / reverse.buy_rate;
  return null;
};

export const formatConverted = (value, currency, decimals = 2) => {
  if (value == null || isNaN(value)) return null;
  return `≈ ${value.toFixed(decimals)} ${currency}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}w`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  const years = Math.floor(days / 365);
  return `${years}y`;
};

export const truncateAddress = (address, start = 8, end = 8) => {
  if (!address || address.length <= start + end) return address;
  return `${address.slice(0, start)}...${address.slice(-end)}`;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    return false;
  }
};

export const shareVoucher = async (voucherCode, value, currency) => {
  const text = `🎁 Voucher Code: ${voucherCode}\nValue: ${value} ${currency}`;
  
  if (navigator.share) {
    try {
      await navigator.share({ text });
      return true;
    } catch (err) {
      return false;
    }
  } else {
    return copyToClipboard(text);
  }
};
